exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".scrollBar {\n  /* width */\n  /* Track */\n  /* Handle */ }\n  .scrollBar::-webkit-scrollbar {\n    width: 5px; }\n  .scrollBar::-webkit-scrollbar-track {\n    border-radius: 5px; }\n  .scrollBar::-webkit-scrollbar-thumb {\n    background: grey;\n    border-radius: 5px; }\n", ""]);

